//region :: Imports ::
import React, {ReactElement} from 'react';
import MComponent from './Toolkit/Components/Component';
import MTopbarButton from './Toolkit/Components/Shell/TopbarButton';
import MShell from './Toolkit/Components/Shell/Shell';
import WithRouterProps from './Toolkit/WithRouterProps';
import withRouter from './Toolkit/WithRouter';
import MAuthenticate from './Toolkit/Components/Auth/Authenticate';
import MAuthorize from './Toolkit/Components/Auth/Authorize';

//endregion

/** */
type Props = WithRouterProps & {}

/** */
class App extends MComponent<Props> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();

    }

    /** */
    private bindMethods(): void {
        this.workersButton_onClick = this.workersButton_onClick.bind(this);
    }

    /** */
    private workersButton_onClick(): void {
        this.props.navigate('/workers');
    }

    /** */
    public render(): ReactElement {

        return (
            <MAuthenticate>
                <MAuthorize roles={['User']}>
                    <MShell appTitle={process.env.REACT_APP_NAME!}
                            topbarButtons={
                                [
                                    <MTopbarButton label="Workers" icon="pi-users" onClick={this.workersButton_onClick}/>
                                ]
                            }/>
                </MAuthorize>
            </MAuthenticate>
        );

    }

}

export default withRouter(App);
